import React from "react";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { TransportType } from "__generated__/graphql";
import { intl } from "LocaleWrapper";

const TransportTypeSelect = ({ value, onChange }: Omit<SelectProps<TransportType, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={Object.values(TransportType)}
			getOptionLabel={option => intl.formatMessage({ id: option })}
			value={value}
			onChange={onChange}
			disableSearch />
	);
};

export default TransportTypeSelect;
